import { enrichTransactions } from './enrich-transactions/index.js'
import { runAnalysisIntercoTransactions } from './run-analysis/index.js'

export function analyseIntercoTransactions (transactions, params = {}) {
  console.log('analyseIntercoTransactions', transactions, params)

  enrichTransactions(transactions, {
    currenciesRates: params.currenciesRates,
    entities: params.entities,
    shownCurrencyCode: params.shownCurrencyCode,
    dateGroupingMethod: params.dateGroupingMethod
  })

  // Sort: largest first, and credit first
  // Ie. aims to identify what matters, in consistent Credit > Debit order
  transactions.sort((a, b) => {
    return Math.abs(b._converted_amount) - Math.abs(a._converted_amount) || Math.sign(a._converted_amount) - Math.sign(b._converted_amount)
  })
  console.log('transactions sorted', transactions)

  const transactionsRollup = runAnalysisIntercoTransactions(transactions)

  return {
    transactionsRollup,
    transactions
  }
}
